import { ChangeEvent, KeyboardEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Search } from 'lucide-react';

import { Input } from '@/components/Input';

import { cn } from '@/lib/utils';

const PLUS_SYMBOL = '+';
const ENTER_KEY = 'Enter';

export const ClientQuickSearchForm = (props: {
  companyId: number;
  className?: string;
}) => {
  const { companyId, className } = props;
  const { t } = useTranslation();

  const [clientId, setClientId] = useState('');

  const openClientPage = (id: string, isFromScanner: boolean) => {
    const formattedClientId = isFromScanner ? id.slice(0, -1) : id;
    const clientUrl = `${location.origin}/companies/${companyId}/clients/${formattedClientId}`;

    window.open(clientUrl, '_blank', 'noopener,noreferrer');
    setClientId('');
  };

  const onClientIdChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setClientId(value);

    // Handle scanner input (ends with +)
    if (value.endsWith(PLUS_SYMBOL)) {
      openClientPage(value, true);
    }
  };

  const onEnterPress = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === ENTER_KEY && clientId) {
      openClientPage(clientId, false);
    }
  };

  return (
    <div className={cn('w-full max-w-80', className)}>
      <Input
        icon={<Search />}
        onKeyDown={onEnterPress}
        value={clientId}
        onChange={onClientIdChange}
        placeholder={t('Find Client by ID')}
      />
    </div>
  );
};
